import EventBus from 'eventing-bus'
import $ from 'jquery'
import Constants from './constants'

const log = (msg, data)=> {
    console.log('[banner]', msg, data)
}


export default function() {

    return {
        state: 'idle',
        files_uploading: [],
        files_remaining: 0,
        completed_uploads: 0,
        total_transferred: 0,
        total_size: 0,
        disable_banner: false,

        progress: function(progress) {
            console.log('[banner] progress', progress.detail)
            const transferred = progress.detail
            if (transferred) {
                this.total_transferred = transferred;
            }
        },

        again: function() {
            this.state = 'idle'
            this.files_uploading = [];
            this.total_transferred = 0;
            this.total_size = 0;
            this.files_remaining = 0;
        },

        finished: function(){
            this.state = 'finished'
            if (this.files_remaining > 0) {
                setTimeout(()=>{
                    this.files_remaining = this.files_remaining - 1;
                }, 500)
            }

            // not hidden
            if (!$('#upload-status').attr('css')) {
                //this.deactivate_navigation();
            }

        },

        remaining: function(count) {
            if (count.detail) {
                this.completed_uploads = this.completed_uploads + 1;
                this.files_remaining = parseInt(count.detail);
            }
        },

        ok: function(){
            this.again();
            let up = $('#upload-status')
            if (up.attr('css')) {
                this.hide_banner();
            }

            $('#new-body').hide();
            up.fadeIn()

            //this.deactivate_navigation();
            this.dispatch(Constants.EVENT_UPLOAD_AGAIN)
            $('.btn-ok').fadeOut()

        },

        start: function(update){
            log('received update', update)
            this.disable_banner = false;
            this.state = 'uploading'
            this.files_uploading = update.detail.files
            this.files_remaining = this.files_uploading.length;
            let total = 0;
            this.files_uploading.map(function(f){
                let s = parseInt(f.size) / 1000000;
                console.log('file size', s, total);
                total = total + s;
            });

            this.total_size = parseFloat(total.toFixed(2));
            console.log('total_size', total);

            this.activate_navigation();
        },

        show_banner: function(){
            this.disable_banner = false;
            $('#new-body').css('top', '80px')
        },

        hide_banner: function(){
            this.disable_banner = true;
            $('#new-body').css('top', '55px')
            this.deactivate_navigation();
        },


        view_status_page: function() {
            console.log('[banner] triggering status view')
            $('#new-body').hide()
            $('#upload-status').fadeIn()
        },

        deactivate_navigation: function(){
            window.navigation_hooked = false;
        },

        activate_navigation: function(){
            window.navigation_hooked = true;
        },

        dispatch: function(key, v) {
            if (!key) { throw new Error("Invalid Key") }
            window.dispatchEvent(new CustomEvent(key, { detail: v }))
        },

    };
}
